import { render, staticRenderFns } from "./PitchModal.vue?vue&type=template&id=8cc4fc24"
import script from "./PitchModal.vue?vue&type=script&lang=js"
export * from "./PitchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports